import {
  Box,
  Button,
  Drawer,
  DrawerHeader,
  DrawerPanel,
  DrawerPopup,
  DrawerTitle,
  Text,
} from "@salestrak/ui";

interface DeletePhotoDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/**
 * Mobile-only confirm for removing a custom-field photo. The remove "×" on a
 * 32px field tile is a tiny, always-visible touch target (no hover gate on
 * touch), so a stray tap would otherwise delete instantly. Presented as a
 * drawer stacked over the issue-view / custom-fields drawer — Base UI
 * coordinates nested layers itself (`--nested-dialogs`), so no stacking
 * behavior is declared here.
 *
 * Desktop keeps the instant hover-revealed "×" (a deliberate pointer move), so
 * this is only rendered on mobile.
 */
export function DeletePhotoDialog({
  open,
  onOpenChange,
  onConfirm,
}: DeletePhotoDialogProps) {
  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerPopup showBar>
        <DrawerHeader>
          <Box direction="row" align="center" justify="between" gap="sm">
            <Button variant="ghost" size="sm" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <DrawerTitle>Remove photo</DrawerTitle>
            {/* Spacer keeps the title optically centered against Cancel. */}
            <Box width={64} />
          </Box>
        </DrawerHeader>
        <DrawerPanel>
          <Box gap="md" paddingY="lg">
            <Text>Remove this photo from the field?</Text>
            <Button
              variant="destructive"
              size="lg"
              onClick={() => {
                onConfirm();
                onOpenChange(false);
              }}
            >
              <Text>Remove</Text>
            </Button>
          </Box>
        </DrawerPanel>
      </DrawerPopup>
    </Drawer>
  );
}
